<template>
  <CustomPage title="销售数据" color="black" bgcolor="white">
    <div slot="content" style="height: 100%">
      <div
        class="flex justify-between text-xs mx-3 mb-3"
        style="color: #666666"
      >
        <div
          class="rounded-full px-2"
          @click="activeTab = 0"
          :class="activeTab === 0 ? 'active' : ''"
        >
          今日
        </div>
        <!-- <div
          class="rounded-full px-2"
          @click="activeTab = 1"
          :class="activeTab === 1 ? 'active' : ''"
        >
          昨日
        </div> -->
        <div
          class="rounded-full px-2"
          @click="activeTab = 2"
          :class="activeTab === 2 ? 'active' : ''"
        >
          本周
        </div>
        <!-- <div
          class="rounded-full px-2"
          @click="activeTab = 3"
          :class="activeTab === 3 ? 'active' : ''"
        >
          本月
        </div> -->
        <div
          class="rounded-full px-2"
          @click="activeTab = 5"
          :class="activeTab === 5 ? 'active' : ''"
        >
          月度
        </div>
        <!-- <div
          class="rounded-full px-2"
          @click="activeTab = 6"
          :class="activeTab === 6 ? 'active' : ''"
        >
          全部
        </div> -->
      </div>
      <div v-if="activeTab !== 6" class="m-3">
        <div class="flex text-xs">
          <div class="font-semibold mx-2 mb-2">店铺数据分析</div>
          <Popover
            v-if="activeTab === 5"
            :offset="[0, 0]"
            v-model="showPopover"
            trigger="click"
            :actions="actions"
            @select="onSelect"
          >
            <template #reference>
              <div class="font-semibold">
                {{ selectedAction
                }}<Icon
                  class="transform rotate-90"
                  name="play"
                  color="#E82035"
                />
              </div>
            </template>
          </Popover>
        </div>

        <div class="statistics heavyshadow rounded-lg mb-3">
          <div class="item">
            <div class="val">{{ data.storeDataAnalysis.amountTotal }}</div>
            <div class="tit">销售额(元)</div>
          </div>
          <div class="item">
            <div class="val">{{ data.storeDataAnalysis.saveProfit }}</div>
            <div class="tit">业绩(元)</div>
          </div>

          <div class="item">
            <div class="val">{{ data.storeDataAnalysis.distMarkup }}</div>
            <div class="tit">收益(元)</div>
          </div>
          <div class="item">
            <div class="val">{{ data.storeDataAnalysis.orderNum }}</div>
            <div class="tit">订单数(笔)</div>
          </div>
        </div>
        <div class="font-semibold mx-2 mb-2 text-xs">访客数据</div>
        <div class="statistics heavyshadow rounded-lg mb-3 justify-between">
          <div class="item">
            <div class="val">{{ data.storeDataAnalysis.visitorNum }}</div>
            <div class="tit">进店人数</div>
          </div>
          <div class="item">
            <div class="val">{{ data.storeDataAnalysis.buyNum }}</div>
            <div class="tit">下单人数</div>
          </div>
          <div class="item">
            <div class="val">{{ data.storeDataAnalysis.atv }}</div>
            <div class="tit">客单价(元)</div>
          </div>
        </div>
        <div class="font-semibold mx-2 mb-2 text-xs">店长团队分析</div>
        <div class="statistics heavyshadow rounded-lg mb-3 flex-wrap">
          <div class="item it3">
            <div class="val">{{ data.teamAnalysis.amountTotal }}</div>
            <div class="tit">销售额(元)</div>
          </div>
          <div class="item it3">
            <div class="val">{{ data.teamAnalysis.saveProfit }}</div>
            <div class="tit">业绩(元)</div>
          </div>
          <div class="item">
            <div class="val">{{ data.teamAnalysis.distMarkup }}</div>
            <div class="tit">店长收益(元)</div>
          </div>
          <div class="item it3">
            <div class="val">{{ data.teamAnalysis.teamContribute }}</div>
            <div class="tit">店长团队贡献(元)</div>
          </div>
          <div class="item it3">
            <div class="val">{{ data.teamAnalysis.orderNum }}</div>
            <div class="tit">订单数(笔)</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="flex">
          <Tabs class="flex-grow" v-model="activeType">
            <Tab title="待结算(1)"></Tab>
            <Tab title="已结算(1)"></Tab>
            <Tab title="已失效(1)"></Tab>
          </Tabs>
          <div class="w-32 text-xs flex items-center justify-center">
            <span>预计赚取:</span
            ><span class="font-bold" style="color: #e82237">¥68.00</span>
          </div>
        </div>
        <div>
          <div v-for="i in 5" :key="i" class="heavyshadow rounded-lg p-3 m-3">
            <div class="flex justify-between mb-2">
              <div class="flex">
                <div style="width: 34px; height: 34px" class="mr-2">
                  <img
                    class="w-full h-full rounded-full"
                    src="https://img01.yzcdn.cn/vant/cat.jpeg"
                    alt=""
                  />
                </div>
                <div class="text-xs">
                  <div>ERNEST</div>
                  <div style="color: #aeaeae">01-03 10:30</div>
                </div>
              </div>
              <div class="text-red text-xs">待结算</div>
            </div>
            <div class="text-xxs flex justify-between">
              <div>NIKE耐克Air Jordan 1 Mid AJ1 男女鞋白...</div>
              <div class="flex">
                <div>实付：¥648</div>
                <div class="text-red ml-2">赚：¥68</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import { getStoreDataAnalysis } from "../webApi";
import { Popover, Icon, Tabs, Tab } from "vant";
export default {
  components: { CustomPage, Popover, Icon, Tabs, Tab },
  created() {
    this.getData();
  },
  data() {
    return {
      activeTab: 0,
      activeType: 0,
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      currentYear: this.dayjs().year(),
      currentMonth: this.dayjs().month() + 1,
      selectedAction: this.dayjs().format("YYYY-MM"),
      data: { storeDataAnalysis: {}, teamAnalysis: {} },
    };
  },
  methods: {
    getData() {
      let params = {
        dateType: null,
        parameter: null,
      };
      switch (this.activeTab) {
        case 0:
          params.dateType = "today";
          break;

        case 2:
          params.dateType = "thisWeek";

          break;

        case 5:
          params.dateType = "certainMonth";
          params.parameter = this.selectedAction;

          break;

        default:
          break;
      }
      getStoreDataAnalysis(params).then(({ data }) => {
        this.data = data;
      });
    },
    onSelect(action) {
      this.activeTab = 5;
      this.selectedAction = action.text;
      this.getData();
    },
  },
  computed: {
    actions() {
      let temp = [];
      for (let i = 0; i < 12; i++) {
        if (this.currentMonth > i) {
          temp.push({
            text: this.dayjs(
              this.currentYear + "-" + (this.currentMonth - i)
            ).format("YYYY-MM"),
          });
        } else {
          temp.push({
            text: this.dayjs(
              this.currentYear - 1 + "-" + (this.currentMonth - i + 12)
            ).format("YYYY-MM"),
          });
        }
      }

      return temp;
    },
  },
  watch: {
    activeTab() {
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.active {
  background-color: #e82035;
  color: white;
}
::v-deep .van-tab--active {
  font-weight: 600;
  color: #e82035;
}
.statistics {
  padding: 22px 18px 22px;
  display: flex;
  .item {
    width: 25%;
    margin-bottom: 12px;
    .val {
      font-size: 32px;
      line-height: 44px;
      color: #e82035;
      font-weight: bold;
    }
    .tit {
      padding-top: 6px;
      font-size: 20px;
      line-height: 28px;
    }
  }
  .it3 {
    margin-right: 82px;
  }
}
</style>